import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'glass' | 'elevated' | 'surface' | 'gradient';
  hoverable?: boolean;
}

export const Card = ({
  children,
  className = '',
  padding = 'md',
  variant = 'default',
  hoverable = false
}: CardProps) => {
  const paddingClasses = {
    none: '',
    sm: 'p-3 xs:p-4',
    md: 'p-4 xs:p-5',
    lg: 'p-5 xs:p-6',
    xl: 'p-6 xs:p-8'
  };

  const variantClasses = {
    default: 'bg-surface-card/80 border border-white/5 shadow-card',
    glass: 'bg-white/[0.04] backdrop-blur-xl border border-cyan-400/10 shadow-card-hover',
    elevated: 'bg-surface-card/90 border border-cyan-400/8 shadow-modal',
    surface: 'bg-[#1e293b]/90 border border-white/5 shadow-subtle',
    gradient: 'bg-gradient-to-br from-[#1a1330]/80 via-[#150f26]/80 to-[#100b1d]/80 border border-cyan-400/10 shadow-card-hover'
  };

  const hoverClass = hoverable ? 'transition-all duration-300 hover:scale-[1.02] hover:shadow-modal cursor-pointer' : '';

  return (
    <div className={`rounded-xl ${paddingClasses[padding]} ${variantClasses[variant]} ${hoverClass} ${className}`}>
      {children}
    </div>
  );
};